module.exports = __webpack_public_path__ + "static/img/cus_18_pre.fc94395b.jpg";